module.exports = __webpack_public_path__ + "img/LoveSprouts Logo (1).1025b3cf.jpg";